export default "__VITE_ASSET__BYSb2dme__"